<template>
  <v-container
    v-if="user"
    fluid
    pa-0
  >
    <v-row>
      <v-col cols="12">
        <div class="d-flex align-start">
          <div class="d-inline-block">
            <v-avatar
              class="brand-green-dark--text brand-text-title rounded mr-4"
              color="brand-primary"
              size="48"
              tile
            >
              {{ toLocaleUpperCase(userInitials) }}
            </v-avatar>
          </div>

          <div class="d-inline-block">
            <div class="brand-text-title brand-green-dark--text">
              {{ user.Info.Firstname }} {{ user.Info.Lastname }}
            </div>

            <div class="brand-text-small brand-grey--text">
              {{ $t('Auth.AccountDialog.MemberSince') }} {{ user.Info.DateAdded }}
            </div>
          </div>
        </div>

        <div class="brand-green-dark--text">
          <div class="mt-4 ml-16">
            <div class="d-inline-flex mr-12">
              <div>
                <div class="brand-text-title">
                  {{ $t('Account.Settings.Field.Phone.Label') }}
                </div>

                <div>
                  {{ user.Info.PhoneInternational }}
                </div>
              </div>
            </div>

            <div class="d-inline-flex">
              <div>
                <div class="brand-text-title">
                  {{ $t('Account.Settings.Field.Email.Label') }}
                </div>

                <div>
                  {{ user.Info.Email }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AccountPersonalInfoMixin from '@/theme/default/views/account/AccountPersonalInfo.js'

export default {
  name  : 'AccountPersonalInfo',
  mixins: [AccountPersonalInfoMixin]
}
</script>

<style scoped src="@/theme/default/views/account/AccountPersonalInfo.css"></style>
<style scoped>
</style>
